var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("defs", [
      _c("path", {
        attrs: {
          id: "geofences@1x-a",
          d:
            "M11.9993999,12.6835196 C11.6225339,12.6835196 11.3152802,12.3774661 11.3152802,11.9993999 C11.3152802,11.6225339 11.6225339,11.3164804 11.9993999,11.3164804 C12.1818318,11.3164804 12.3546621,11.3872928 12.4830845,11.5157153 C12.611507,11.6453379 12.6835196,11.816968 12.6835196,11.9993999 C12.6835196,12.3774661 12.3762658,12.6835196 11.9993999,12.6835196 M19.2354662,11.2360663 C18.8153927,11.2360663 18.4721326,11.5793264 18.4721326,11.9993999 C18.4721326,15.5688245 15.5688245,18.4721326 11.9993999,18.4721326 C8.43117546,18.4721326 5.52666717,15.5688245 5.52666717,11.9993999 C5.52666717,8.43117546 8.43117546,5.52666717 11.9993999,5.52666717 C13.4588553,5.52666717 14.8679019,6.01755307 16.0045008,6.91531018 L15.0299302,7.88988073 C14.1513765,7.23816668 13.1095942,6.89490661 11.9993999,6.89490661 C9.18490736,6.89490661 6.89490661,9.18490736 6.89490661,11.9993999 C6.89490661,14.8150926 9.18490736,17.1050934 11.9993999,17.1050934 C14.8138924,17.1050934 17.1038932,14.8150926 17.1038932,11.9993999 C17.1038932,11.5793264 16.7618333,11.2360663 16.3405596,11.2360663 C15.9204861,11.2360663 15.5784262,11.5793264 15.5784262,11.9993999 C15.5784262,13.9725452 13.9725452,15.5784262 11.9993999,15.5784262 C10.0262546,15.5784262 8.42157378,13.9725452 8.42157378,11.9993999 C8.42157378,10.0262546 10.0262546,8.42157378 11.9993999,8.42157378 C12.6967219,8.42157378 13.3580377,8.6160078 13.9329383,8.9868727 L12.9271623,9.99264871 C12.6379116,9.8594254 12.3222564,9.78861301 11.9993999,9.78861301 C10.7799865,9.78861301 9.78861301,10.7811867 9.78861301,11.9993999 C9.78861301,13.2188133 10.7799865,14.2101868 11.9993999,14.2101868 C13.2188133,14.2101868 14.2101868,13.2188133 14.2101868,11.9993999 C14.2101868,11.6777436 14.1405746,11.3608882 14.0061511,11.0716375 L17.6559898,7.42299902 C17.800015,7.27897382 17.8792289,7.08694021 17.8792289,6.88290451 C17.8792289,6.6788688 17.800015,6.4868352 17.6559898,6.34280999 C16.1449254,4.83174556 14.1357738,4 11.9993999,4 C9.86302603,4 7.85387443,4.83174556 6.34280999,6.34280999 C4.83174556,7.85387443 4,9.86302603 4,11.9993999 C4,14.136974 4.83174556,16.1461256 6.34280999,17.6559898 C7.85387443,19.1670542 9.86302603,20 11.9993999,20 C14.1357738,20 16.1449254,19.1670542 17.6559898,17.6559898 C19.1670542,16.1461256 19.9987998,14.136974 19.9987998,11.9993999 C19.9987998,11.5793264 19.6567399,11.2360663 19.2354662,11.2360663"
        }
      })
    ]),
    _vm._v(" "),
    _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
      _c("rect", {
        staticStyle: { "mix-blend-mode": "color-burn" },
        attrs: {
          width: "24",
          height: "24",
          fill: "#E3E3E3",
          "fill-opacity": ".01"
        }
      }),
      _vm._v(" "),
      _c("use", {
        attrs: {
          fill: _vm.currentColor,
          opacity: _vm.opacity,
          "xlink:href": "#geofences@1x-a"
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }